import {AdvertDTO} from '../advertDTO.interface';
import {VehicleDTO} from '../Vehicle/vehicleDTO.interface';

export interface NewAdvertDTO {
  advert: AdvertDTO;
  vehicle: VehicleDTO;
}
